<button (click)="onClick()">
    <span></span>
    <span></span>
    <span></span>
</button>
